import { createContext } from 'react'

/**
 * The chat a Coach report block is shown in. The floating chat and the insight feedback dialog
 * give their open thread, so a card that sends the person to another site (connecting Canva) can
 * bring them back to it in the floating chat. Other places that show report blocks give nothing.
 */
export interface CoachChatContextValue {
  sessionId?: string | null
  /**
   * Sends a message to Coach in this chat as if the person had typed it (e.g. the Google Drive
   * files they picked). False when it was not sent: the chat is busy or not ready. Only the
   * floating chat gives one.
   */
  sendMessage?: (text: string) => boolean
  /**
   * The site the person just came back to this thread from without connecting it ('canva' or
   * 'googleDrive': they declined, or the sign-in failed). Only the floating chat gives one.
   */
  connectFailed?: string
}

export const CoachChatContext = createContext<CoachChatContextValue>({})

// Thread ids are UUIDs. Anything else (e.g. from a hand-made link) is never put in a link or opened.
const SESSION_ID = /^[A-Za-z0-9_-]{1,128}$/

/** True for a value that can be a Coach thread id. */
export const isCoachSessionId = (value: unknown): value is string =>
  typeof value === 'string' && SESSION_ID.test(value)
